import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import BlankSlate from 'modules/payroll_bundle/components/BlankSlate'

const NoPoliciesPage = () => {
  return (
    <ResponsivePage.Body showHeader={false}>
      <Box
        gap="s24"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        height="full"
        width="full"
      >
        <BlankSlate
          label={i18n.t('payroll_bundle.no_policies.blank_slate.title')}
          message={i18n.t('payroll_bundle.no_policies.blank_slate.message')}
          withIcon
          uploaded
        />
      </Box>
    </ResponsivePage.Body>
  )
}

export default NoPoliciesPage
